import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReceiptDownloadService {
  constructor(private readonly http: HttpClient) {}

  downloadZip(pacReference: string): Observable<Blob> {
    const token = localStorage.getItem('authToken');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'X-App-Name': 'JPP-FE'
    });

    return this.http.post('api/receipts/download-zip', { pacReference }, {
      headers,
      responseType: 'blob'
    });
  }

  downloadReceipt(pacReference: string) {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${localStorage.getItem('authToken') || ''}`,
      'X-App-Name': 'JPP-FE'
    });

    return this.http.post('api/receipts/download-receipt', { pacReference }, {
      headers,
      responseType: 'blob',
      observe: 'response'
    });
  }

}
